import { IDVGroupMarkers, PEPGroupMarkers, RiskRatingGroupMarkers, SanctionsGroupMarkers } from "../../constant/markerConstant";
import { AmlStatusEnum, InvestorName } from "../../model";
import { OnboardingModel } from "../../constant/amlConstant";

// AML API
type ReviewListCounts = {
  [k in AmlStatusEnum]: number;
} & {
  [PEPGroupMarkers.REF]: number;
  [SanctionsGroupMarkers.REF]: number;
  [IDVGroupMarkers.REF]: number;
  [RiskRatingGroupMarkers.REF]: number;
};

export type InvestorAmlOverview = {
  personId: string;
  amlStatus: AmlStatusEnum,
  onboardingDate: string;
  onboardingAccountId: string;
  idv: string;
  idvDescription: string;
  pep: string;
  pepDescription: string;
  riskRating: string;
  customerName: string;
  riskRatingDescription: string;
  sanctions: string;
  sanctionsDescription: string;
  assignee: string;
} & InvestorName;

export type SubCustomerResponse = {
  payload: SubCustomerPayload
};

export type SubCustomerPayload = {
  showCustomerFilter: boolean,
  customers: SubCustomer[]
};

export type SubCustomer = {
  customerId: string,
  name: string
};

export type ReviewListResponse = {
  total: number;
  counts: ReviewListCounts,
  rows: InvestorAmlOverview[]
};

export function amlReviewListTransformer(response: any): ReviewListResponse {
  return {
    total: response.total,
    counts: response.statusCount,
    rows: response.rows.map(amlReviewListItemTransformer)
  };
}

export function amlReviewListItemTransformer(row: any): InvestorAmlOverview {
  return {
    personId: row.personId,
    amlStatus: row.amlStatus,
    onboardingDate: row.createOnDate,
    onboardingAccountId: row.onboardingAccountId,
    idv: row.idAndV,
    idvDescription: row.idAndVDescription,
    pep: row.pep,
    pepDescription: row.pepDescription,
    riskRating: row.riskRating,
    customerName: row.customerName,
    riskRatingDescription: row.riskRatingDescription,
    sanctions: row.sanctions,
    sanctionsDescription: row.sanctionsDescription,
    assignee: row.assignedUser,
    title: row.title,
    entityType: row.entityType,
    entityName: row.entityName,
    firstName: row.firstName,
    middleName: row.middleName,
    surname: row.surname
  };
}

export type InvestorAmlDetail = InvestorName & {
  onboardingAccountId: string;
  customerName: string;
  customerId: string;
  personId: string;
  onboardingDate: string;
  onboardingModel: (typeof OnboardingModel)[keyof typeof OnboardingModel];
  status: AmlStatusEnum;
  upliftData: {
    upliftStatus?: string;
    upliftDate?: string;
  }
};

export function investorAmlDetailTransformer(data: any): InvestorAmlDetail {
  return {
    personId: data.personId,
    title: data.title,
    entityType: data.entityType,
    entityName: data.entityName,
    firstName: data.firstName,
    middleName: data.middleName,
    surname: data.surname,
    onboardingAccountId: data.onboardingAccountId,
    onboardingModel: data.onboardingModel,
    onboardingDate: data.onboardingDate,
    customerName: data.customerName,
    customerId: data.customerId,
    status: data.status,
    upliftData: {
      upliftStatus: data.upliftData?.upliftStatus,
      upliftDate: data.upliftData?.plannedDate
    }
  };
}

export type InvestorAmlResultInHistory = {
  resultValue: string;
  resultType: string;
}

export type InvestorAmlHistoryItem = {
  personId: string;
  resultDate: string;
  resultExtLink: string;
  supplierLink: string;
  resultPdfExt_dvUrn: string;
  resultPdfInt_dvUrn: string;
  onboardingSource: string;
  results: InvestorAmlResultInHistory[];
}

export function investorAmlHistoryTransformer(data: any): InvestorAmlHistoryItem {
  return {
    personId: data.personId,
    resultDate: data.resultDate,
    supplierLink: data.supplierLink,
    resultExtLink: data.resultExtLink,
    resultPdfExt_dvUrn: data.resultPdfExt_dvUrn,
    resultPdfInt_dvUrn: data.resultPdfInt_dvUrn,
    onboardingSource: data.onboardingSource,
    results: data.results.map((el: any): InvestorAmlResultInHistory => {
      return {
        resultValue: el.resultValue,
        resultType: el.resultType,
      };
    })
  };
}

export type AssignRequestPayload = {
  employeeId: string;
  customerId: string;
  employeeName: string;
}

export type StatusUpdatePayload = {
  sendNotification: boolean;
  status: string;
  comment?: string;
}

export type TimeLineItem = {
  comment: string;
  date: number;
  eventDescription: string;
  sourceId: string;
  statusApplied: AmlStatusEnum;
  time: number;
};

export function TimeLineTransformer(data: any): TimeLineItem {
  return {
    comment: data.comment,
    date: data.date,
    eventDescription: data.eventDescription,
    sourceId: data.sourceId,
    statusApplied: data.statusApplied,
    time: data.time,
  };
}
